import Flex from 'components/Flex'
import {
  StyledCheckbox,
  StyledGroup,
} from 'components/UIComponents/FilterCheckBoxComp/style'
import React from 'react'

const FilterCheckBoxComp = ({
  options,
  onChange,
  value = [],
  padding = '1rem 10px !important',
  valueParam = 'value',
  labelParam = 'label',
  margin,
  style,
}) => {
  return (
    <StyledGroup
      onChange={onChange}
      value={value}
      margin={margin}
      style={style}
    >
      {options?.map(item => (
        <Flex spaceBetween centerVertically key={item[valueParam]}>
          <StyledCheckbox
            key={item[valueParam]}
            value={item[valueParam]}
            label={item[labelParam]}
            disabled={item['disabled']} 
            padding={padding}
          />
        </Flex>
      ))}
    </StyledGroup>
  )
}

export default FilterCheckBoxComp
